import { tv } from 'tailwind-variants';

export const styles = tv({
  slots: {
    base: 'mt-3.5 w-full max-w-243 lg:mt-6 lg:px-7.5',
    label: 'heading-xs lg:heading-s text-secondary-hover',
    value: 'heading-s lg:heading-m text-right lg:w-150 lg:text-left',
    brand: 'heading-s-intr-bold uppercase',
    link: 'underline underline-offset-4'
  }
});
